"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GuaranteeProductReturn_vue_1 = __importDefault(require("../../pages/guaranteeProductReturn/GuaranteeProductReturn.vue"));
const CustomerProductReturn_vue_1 = __importDefault(require("../../pages/customerProductReturn/CustomerProductReturn.vue"));
const CarcassReturn_vue_1 = __importDefault(require("../../pages/carcassReturn/CarcassReturn.vue"));
exports.default = [
    {
        name: 'product_return_guarantee',
        path: '/product-return/guarantee',
        component: GuaranteeProductReturn_vue_1.default,
        meta: { requiresAuth: true, title: 'Guarantee Product Return' }
    },
    {
        name: 'product_return_customer',
        path: '/product-return/customer',
        component: CustomerProductReturn_vue_1.default,
        meta: { requiresAuth: true, title: 'Customer Product Return' }
    },
    {
        name: 'carcass_return',
        path: '/product-return/carcass-return',
        component: CarcassReturn_vue_1.default,
        meta: { requiresAuth: true, title: 'Carcass Return' }
    },
];
